/* TWRD header icons: hide the bag counter badge when the cart is empty. */
(function () {
  'use strict';

  function sync() {
    var bubbles = document.querySelectorAll('.cart-count-bubble');
    Array.prototype.forEach.call(bubbles, function (bubble) {
      var counter = bubble.querySelector('items-count');
      var raw = counter ? counter.textContent : bubble.textContent;
      var count = parseInt((raw || '').trim(), 10);
      if (isNaN(count)) count = 0;
      bubble.setAttribute('data-count', count);
    });
  }

  function observe() {
    var counters = document.querySelectorAll('.cart-count-bubble items-count');
    if (!counters.length || !window.MutationObserver) return;
    var observer = new MutationObserver(sync);
    Array.prototype.forEach.call(counters, function (node) {
      observer.observe(node, { childList: true, characterData: true, subtree: true });
    });
  }

  function init() {
    sync();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('cart:updated', sync);
  document.addEventListener('cart:refresh', sync);
})();
